<template>
  <section>
    <header-component/>

    <main class="fixed" v-if="episode">
      <section class="podcast-description">
        <div class="container">
          <div class="podcast-description__image" v-if="episode.image">
            <img :src="episode.image.url" :alt="episode.image.alt">
          </div>
          <div class="podcast-description__text">
            <h1>{{ episode.title }}</h1>
            <span class="subtitle" v-if="episode.subtitle">{{ episode.subtitle }}</span>
            <div class="controls">
              <button class="play" @click.prevent="handlePlayButton">
                <i :class="{'icon-play': !this.isCurrentEpisodePlaying, 'icon-pause': this.isCurrentEpisodePlaying}"></i>
                <span class="sr-only">{{ this.isCurrentEpisodePlaying ? 'Pause' : 'Play' }}</span>
              </button>
              <a href="#" @click.prevent="shareTwitter" class="btn"><i class="icon-twitter"></i> Tweet</a>
              <a href="#" @click.prevent="shareEmail" class="btn"><i class="icon-envelope"></i> E-mail</a>
              <div class="links">
                <a v-for="(link, index) in episode.links" :key="index" :href="link.url" target="_blank"
                   rel="nofollow">
                  <img :src="link.logo.url" :alt="link.logo.alt" v-if="link.logo">
                  <span v-if="link.label">{{ link.label }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="podcast-content">
        <div class="container">
          <div class="podcast-content__about">
            <h2>About</h2>
            <div class="text">
              <p v-html="showMore ? episode.about : shortDescription"/>
              <p><a href="#" @click.prevent="showMore = true" v-if="!showMore">See more</a></p>

            </div>
          </div>
          <div class="podcast-content__episodes">
            <h2>Episodes</h2>
            <div class="list" v-if="episodes.length > 0">
              <podcast-item v-for="currentEpisode in episodes" :key="currentEpisode.id"
                            :class="{'item-selected': currentEpisode.id === episode.id}"
                            @play="handlePlayButton"
                            :episode="currentEpisode"/>
            </div>
            <div class="list" v-else>
              <h4>No other episodes in the current season</h4>
            </div>
          </div>
        </div>
      </section>
      <player v-if="episode && episode_data"
              :episode="episode"
              :data="episode_data"
              ref="player"
              :isHasPreviousTrack="!!previousTrack"
              :isHasNextTrack="!!nextTrack"
              @previous-track="handlePreviousTrack"
              @next-track="handleNextTrack"/>
    </main>
  </section>
</template>
<script>
import HeaderComponent from "../components/Podcast/HeaderComponent";
import PodcastItem from "../components/Index/PodcastItem";
import Player from "../components/Podcast/Player";

export default {
  components: {Player, PodcastItem, HeaderComponent},
  data: () => ({
    loading: true,
    episode: null,
    episode_data: null,
    episodes: [],
    showMore: false,
  }),
  mounted() {
    this.loadEpisode()
  },
  computed: {
    shortDescription() {
      return this.episode.about_raw ? this.episode.about_raw.substring(0, 512) + '...' : null;
    },
    filteredEpisodes() {
      return this.episodes.filter(episode => this.episode && episode.id !== this.episode.id)
    },
    nextTrack() {
      const currentIndex = this.episodes.findIndex(episode => episode.id === this.episode.id)

      if (-1 === currentIndex || this.episodes.length <= currentIndex) {
        return null;
      }

      return this.episodes[currentIndex + 1]
    },
    previousTrack() {
      const currentIndex = this.episodes.findIndex(episode => episode.id === this.episode.id)

      if (-1 === currentIndex || 0 === currentIndex) {
        return null;
      }

      return this.episodes[currentIndex - 1]
    },
    isCurrentEpisodePlaying() {
      const currentEpisode = this.$store.getters['podcast/episode']

      if (!currentEpisode || currentEpisode.id !== this.episode.id) {
        return false;
      }

      return this.$store.getters['podcast/isPlaying'] || false
    }
  },
  watch: {
    '$route.params.id': {
      handler: function () {
        this.showMore = false;
        this.loadEpisode()
      }
    }
  },
  methods: {
    shareTwitter() {
      const title = encodeURIComponent(document.getElementsByTagName('title')[0].innerHTML + ' | ' + this.episode.title);
      window.open('https://twitter.com/share?text=' + title + '&url=' + encodeURIComponent(document.location.href), 'sharer', 'toolbar=1,status=1,menubar=1');
    },
    shareEmail() {
      const title = encodeURIComponent(document.getElementsByTagName('title')[0].innerHTML + ' | ' + this.episode.title);
      window.open('mailto:?&subject=' + title + '&body=' + title + ' ' + encodeURIComponent(document.location.href));
    },
    loadEpisode() {
      const episodeId = this.$route.params.id;

      this.$axios.get(`/wp-json/podcasts/v1/podcasts/${episodeId}`).then(r => {
        this.episode = r.data

        if (!this.episode.audio_file) {
          this.$router.push({name: 'index'})
        } else {
          this.loadEpisodeData()
          this.loadingEpisodes()
        }
      }).catch(() => {
        this.$router.push({name: 'index'})
      })
    },
    loadEpisodeData() {
      this.$wmtVideoAxios.get(`/api/v1/ext/video/${this.episode.audio_file}/config.json`).then(r => {
        this.episode_data = r.data.data

        this.loading = false;
      }).catch(() => {
        this.$router.push({name: 'index'})
      })
    },
    loadingEpisodes() {
      if (!this.episode.seasons.length) {
        return;
      }

      const params = {
        seasons: this.episode.seasons.map(season => season.id)
      }

      this.$axios.get('/wp-json/podcasts/v1/podcasts', {
        params
      }).then(r => {
        this.episodes = r.data
      })
    },
    handlePlayButton() {
      this.$refs.player.handlePlayButton()
    },
    handlePreviousTrack() {
      if (!this.previousTrack) {
        return;
      }

      this.$router.push({name: 'podcast', params: {id: this.previousTrack.id}})
    },
    handleNextTrack() {
      if (!this.nextTrack) {
        return;
      }

      this.$router.push({name: 'podcast', params: {id: this.nextTrack.id}})
    }
  }
}
</script>
